import { render, staticRenderFns } from "./DelayInfoCard.vue?vue&type=template&id=13c7d5ec&scoped=true&"
import script from "./DelayInfoCard.vue?vue&type=script&lang=js&"
export * from "./DelayInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./DelayInfoCard.vue?vue&type=style&index=0&id=13c7d5ec&scoped=true&lang=css&"
import style1 from "./DelayInfoCard.vue?vue&type=style&index=1&id=13c7d5ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c7d5ec",
  null
  
)

export default component.exports